import React, { FC, Dispatch, SetStateAction } from 'react'
import dynamic from 'next/dynamic'
import noSSR from 'components/DynamicLoader'

type Props = {
  setShouldLoadComponent: Dispatch<SetStateAction<boolean>>
}
const ArtistArtworksCarousel = dynamic(
  import(
    /* webpackChunkName: "ArtistArtworksCarousel" */
    './Carousel'
  ),
  noSSR
)

const ArtistArtworks: FC<Props> = (props) => {
  const { setShouldLoadComponent } = props

  return <ArtistArtworksCarousel setShouldLoadComponent={setShouldLoadComponent} />
}

export default ArtistArtworks
